import BorrowerOnboardingBanner from './borrower-onboarding-banner';

export default BorrowerOnboardingBanner;
